import {
  VIEW_SETTINGS_SAVE,
  VIEW_SETTINGS_LOAD,
  VIEW_SETTINGS_CLEAR
} from './actions.type';

const KEY = 'viewSettings';

const initialState = {
  compositionId: null,
  resolution: null,
  zoom: null,
  center: null
};

const state = Object.assign({}, initialState);

const actions = {
  [VIEW_SETTINGS_SAVE](context) {
    let viewSettings = {
      resolution: context.rootGetters.resolution,
      zoom: context.rootGetters.zoom,
      center: context.rootGetters.viewCenter,
      compositionId: (context.rootGetters.composition || {}).id,
      layers: (context.rootGetters.layers || []).map(x => {
        return {
          id: x.id,
          styleId: x.styleId,
          visible: x.visible
        };
      }),
      systemLayersExpanded: context.rootGetters.systemLayersExpanded,
      mvtLayersExpanded: context.rootGetters.mvtLayersExpanded,
      pwidLayersExpanded: context.rootGetters.pwidLayersExpanded,
      archiveLayersExpanded: context.rootGetters.archiveLayersExpanded,
      userLayersExpanded: context.rootGetters.userLayersExpanded,
      compositionLayersExpanded: context.rootGetters.compositionLayersExpanded,
      backgroundLayersExpanded: context.rootGetters.backgroundLayersExpanded
    };

    localStorage.setItem(KEY, JSON.stringify(viewSettings));
  },

  [VIEW_SETTINGS_LOAD](context) {
    let viewSettings = JSON.parse(localStorage.getItem(KEY)) || {};

    context.commit('setStoredCompositionId', viewSettings.compositionId);
    context.commit('setStoredResolution', viewSettings.resolution);
    context.commit('setStoredZoom', viewSettings.zoom);
    context.commit('setStoredCenter', viewSettings.center);
    context.commit('setStoredLayers', viewSettings.layers);
    context.commit(
      'setStoredSystemLayersExpanded',
      viewSettings.systemLayersExpanded
    );
    context.commit(
      'setStoredMvtLayersExpanded',
      viewSettings.mvtLayersExpanded
    );
    context.commit(
      'setStoredPwidLayersExpanded',
      viewSettings.pwidLayersExpanded
    );
    context.commit(
      'setStoredArchiveLayersExpanded',
      viewSettings.archiveLayersExpanded
    );
    context.commit(
      'setStoredUserLayersExpanded',
      viewSettings.userLayersExpanded
    );
    context.commit(
      'setStoredCompositionLayersExpanded',
      viewSettings.compositionLayersExpanded
    );
    context.commit(
      'setStoredBackgroundLayersExpanded',
      viewSettings.backgroundLayersExpanded
    );
  },

  [VIEW_SETTINGS_CLEAR]() {
    localStorage.removeItem(KEY);
  }
};

const mutations = {
  setStoredCompositionId(state, value) {
    state.compositionId = value;
  },
  setStoredResolution(state, value) {
    state.resolution = value;
  },
  setStoredZoom(state, value) {
    state.zoom = value;
  },
  setStoredCenter(state, value) {
    state.center = value;
  },
  setStoredLayers(state, value) {
    state.layers = value;
  },
  setStoredSystemLayersExpanded(state, value) {
    state.systemLayersExpanded = Boolean(value);
  },
  setStoredMvtLayersExpanded(state, value) {
    state.mvtLayersExpanded = Boolean(value);
  },
  setStoredPwidLayersExpanded(state, value) {
    state.pwidLayersExpanded = Boolean(value);
  },
  setStoredArchiveLayersExpanded(state, value) {
    state.archiveLayersExpanded = Boolean(value);
  },
  setStoredUserLayersExpanded(state, value) {
    state.userLayersExpanded = Boolean(value);
  },
  setStoredCompositionLayersExpanded(state, value) {
    state.compositionLayersExpanded = Boolean(value);
  },
  setStoredBackgroundLayersExpanded(state, value) {
    state.backgroundLayersExpanded = Boolean(value);
  }
};

const getters = {
  storedCompositionId: state => state.compositionId,
  storedResolution: state => state.resolution,
  storedZoom: state => state.zoom,
  storedCenter: state => state.center,
  storedLayers: state => state.layers,
  storedLayerVisible: state => id => {
    return ((state.layers || []).find(x => x.id === id) || {}).visible;
  },
  storedLayerStyleId: state => id => {
    return ((state.layers || []).find(x => x.id === id) || {}).styleId;
  },
  storedSystemLayersExpanded: state => state.systemLayersExpanded,
  storedMvtLayersExpanded: state => state.mvtLayersExpanded,
  storedPwidLayersExpanded: state => state.pwidLayersExpanded,
  storedArchiveLayersExpanded: state => state.archiveLayersExpanded,
  storedUserLayersExpanded: state => state.userLayersExpanded,
  storedCompositionLayersExpanded: state => state.compositionLayersExpanded,
  storedBackgroundLayersExpanded: state => state.backgroundLayersExpanded
};

export default {
  actions,
  state,
  mutations,
  getters
};
